var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"layadmin-tabspage-none",class:[{ 'layadmin-view-sm': _vm.$store.state.style.isSmView,
            'layadmin-view-xs': !_vm.$store.state.style.isSmView,
            'layadmin-side-shrink': _vm.$store.state.style.sideShrink}, _vm.$store.state.style.currentTheme]},[_c('div',{staticClass:"layui-layout layui-layout-admin"},[_c('TopBar'),_c('LeftNav'),_c('RightTabs')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }